module.exports = __webpack_public_path__ + "images/store_case_study/takagai-pic1_d8230ff69c4e1370a9508beda9e64b0a.png";